import { render, staticRenderFns } from "./CharacterManagement.vue?vue&type=template&id=1fff7816&"
import script from "./CharacterManagement.vue?vue&type=script&lang=js&"
export * from "./CharacterManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports